module.exports = __webpack_public_path__ + "static/media/nozomi-arimura.9c1a2f61.jpg";